import { useEffect } from 'react';
import useRestore from './actions/restore';
import useDesignStore from './useDesignStore';

export default function useActions() {
  const initial = useDesignStore((state) => state.initial);
  const level = useDesignStore((state) => state.level);
  const revision = useDesignStore((state) => state.revision);
  const setActions = useDesignStore((state) => state.setActions);
  const setFocus = useDesignStore((state) => state.setFocus);

  const restore = useRestore(revision, level);
  useEffect(() => {
    setActions({ restore });
  }, [restore]);

  useEffect(() => {
    setActions({ home: () => setFocus(initial) });
  }, [initial]);
}
